import { render, staticRenderFns } from "./home_component.vue?vue&type=template&id=3b64211a&scoped=true"
import script from "./home_component.vue?vue&type=script&lang=js"
export * from "./home_component.vue?vue&type=script&lang=js"
import style0 from "./home_component.vue?vue&type=style&index=0&id=3b64211a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64211a",
  null
  
)

export default component.exports